import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Layout/Header';
import FooterPremium from '../Layout/FooterPremium';
import PageTitle from '../Layout/PageTitle';
import { FLOOR_PLAN_ITEMS } from '../../data/floorPlans';
import PlanSelect from '../Element/PlanSelect';
import typeaImg from '../../images/plan/typea.png';
import typebImg from '../../images/plan/typeb.png';
import typecImg from '../../images/plan/typec.png';
import typedImg from '../../images/plan/typed.png';
import typeeImg from '../../images/plan/typee.png';

import './FloorPlans.css';

import { sendContactEmail } from '../../api/emailsender/EmailSender';
import { serializeForm } from '../../api/emailsender/formSerialize';

const PLAN_IMAGES = { typea: typeaImg, typeb: typebImg, typec: typecImg, typed: typedImg, typee: typeeImg };

class FloorPlans extends Component {
	observer = null;
	state = { showCustomizedModal: false, selectedPlan: '', customizedPlanSubmitting: false, customizedPlanError: '' };

	handleCustomizedPlanSubmit = async (e) => {
		e.preventDefault();
		const form = e.currentTarget;
		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}
		this.setState({ customizedPlanSubmitting: true, customizedPlanError: '' });
		const formData = serializeForm(form);
		formData.formSource = 'Floor Plans page';
		const result = await sendContactEmail(formData, 'Star Giga — Customized plan request');
		this.setState({ customizedPlanSubmitting: false });
		if (result.ok) {
			form.reset();
			this.setState({ showCustomizedModal: false });
			alert('Thank you! We will contact you shortly with your customized plan.');
		} else {
			this.setState({ customizedPlanError: result.error });
			alert(result.error);
		}
	};

	componentDidMount() {
		this.observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('fp-visible');
					}
				});
			},
			{ rootMargin: '0px 0px -60px 0px', threshold: 0.05 }
		);
		setTimeout(() => {
			document.querySelectorAll('.fp-animate').forEach((el) => this.observer?.observe(el));
		}, 150);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.showCustomizedModal !== prevState.showCustomizedModal) {
			document.body.style.overflow = this.state.showCustomizedModal ? 'hidden' : '';
		}
	}

	componentWillUnmount() {
		this.observer?.disconnect();
		document.body.style.overflow = '';
	}

	render() {
		return (
			<Fragment>
				<Header />
				<div className="page-content fp-page">
					<PageTitle motherMenu="Projects" activeMenu="Floor Plans" />

					{/* Floor Plans Section - Premium UI */}
					<section className="fp-section">
						<div className="container">
							<div className="fp-section-head text-center fp-animate" data-animate="up">
								<h2 className="fp-section-title">FLOOR PLANS</h2>
								<p className="fp-section-subtitle">
									Goldcrest Dreams Tower C, Emirates City Ajman
								</p>
								<p className="fp-section-desc">
									Explore our thoughtfully designed layouts. Each plan is crafted to maximize space, natural light, and functionality, offering you the perfect living experience in the UAE.
								</p>
								<div className="fp-section-line" />
							</div>

							{FLOOR_PLAN_ITEMS.map((plan, index) => {
								const isImageLeft = index % 2 === 1;
								const planImage = PLAN_IMAGES[plan.imageKey] || typeaImg;
								return (
									<div key={index} className="fp-plan-row fp-animate" data-animate="up">
										<div className={`row align-items-stretch fp-plan-inner ${isImageLeft ? 'fp-image-left' : ''}`}>
											<div className={`col-lg-4 order-lg-1 mb-4 mb-lg-0 ${isImageLeft ? 'order-lg-2' : ''}`}>
												<div className="fp-plan-content">
													<h3 className="fp-plan-name">{plan.name}</h3>
													<p className="fp-plan-sqft">{plan.sqft}</p>
													<div className="fp-plan-features-grid">
														<ul className="fp-plan-features">
															{plan.features.slice(0, Math.ceil(plan.features.length / 2)).map((f, i) => (
																<li key={i}>{f}</li>
															))}
														</ul>
														<ul className="fp-plan-features">
															{plan.features.slice(Math.ceil(plan.features.length / 2)).map((f, i) => (
																<li key={i}>{f}</li>
															))}
														</ul>
													</div>
													<div className="fp-plan-pricing">
														<div className="fp-plan-price-row">
															<span className="fp-plan-label">Total Price</span>
															<span className="fp-plan-value">{plan.totalPrice}</span>
														</div>
														<div className="fp-plan-price-row">
															<span className="fp-plan-label">Per SQ FT</span>
															<span className="fp-plan-value">{plan.pricePerSqft}</span>
														</div>
														<div className="fp-plan-monthly">
															<span className="fp-plan-monthly-label">Monthly Payment</span>
															<span className="fp-plan-monthly-value">{plan.monthlyPayment} /MONTH</span>
														</div>
														<p className="fp-plan-down">{plan.downPayment}</p>
													</div>
													<div className="fp-plan-buttons">
														<Link to="/contact-us" className="fp-plan-btn fp-plan-btn-touch">
															Get in Touch
														</Link>
														<button
															type="button"
															className="fp-plan-btn fp-plan-btn-custom"
															onClick={() => this.setState({ showCustomizedModal: true, selectedPlan: plan.name })}
														>
															Customized Plan
														</button>
													</div>
												</div>
											</div>
											<div className={`col-lg-8 order-lg-2 ${isImageLeft ? 'order-lg-1' : ''}`}>
												<div className="fp-plan-image-wrap">
													<img src={planImage} alt={plan.name} className="fp-plan-image" />
												</div>
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</section>

					{/* Customized Plan Modal */}
					{this.state.showCustomizedModal && (
						<div className="fp-modal-overlay" onClick={() => this.setState({ showCustomizedModal: false })}>
							<div className="fp-modal" onClick={(e) => e.stopPropagation()}>
								<button
									type="button"
									className="fp-modal-close"
									aria-label="Close"
									onClick={() => this.setState({ showCustomizedModal: false })}
								>
									×
								</button>
								<div className="fp-modal-header">
									<h3>Request Customized Plan</h3>
									<p>Tell us your requirements and we&apos;ll create a tailored plan for you</p>
								</div>
								<form className="fp-modal-form" onSubmit={this.handleCustomizedPlanSubmit}>
									<input type="hidden" name="plan" value={this.state.selectedPlan} />
									<div className="fp-form-row fp-form-row-2">
										<div className="fp-form-group">
											<label htmlFor="fp-name">Full Name *</label>
											<input id="fp-name" name="name" type="text" required placeholder="Name" />
										</div>
										<div className="fp-form-group">
											<label htmlFor="fp-phone">Phone *</label>
											<input id="fp-phone" name="phone" type="tel" required placeholder="+971 67 412 344" />
										</div>
									</div>
									<div className="fp-form-group">
										<label htmlFor="fp-plan-interest">Plan of Interest</label>
										<PlanSelect
											id="fp-plan-interest"
											name="planInterest"
											plans={FLOOR_PLAN_ITEMS}
											defaultValue={this.state.selectedPlan || (FLOOR_PLAN_ITEMS[0] && FLOOR_PLAN_ITEMS[0].name)}
										/>
									</div>
									<div className="fp-form-row fp-form-row-2">
										<div className="fp-form-group">
											<label htmlFor="fp-installments">Installments</label>
											<PlanSelect
												id="fp-installments"
												name="installments"
												plans={[
													{ name: '1 Year' },
													{ name: '2 Years' },
													{ name: '3 Years' },
													{ name: '4 Years' },
													{ name: '5 Years' },
												]}
												defaultValue="1 Year"
											/>
										</div>
										<div className="fp-form-group">
											<label htmlFor="fp-advance-payment">Advance Payment</label>
											<input
												id="fp-advance-payment"
												name="advancePayment"
												type="text"
												placeholder="e.g. AED 50,000"
											/>
										</div>
									</div>
									<div className="fp-form-group">
										<label htmlFor="fp-requirements">Your Requirements *</label>
										<textarea
											id="fp-requirements"
											name="requirements"
											rows="4"
											required
											placeholder="Describe your customization needs: room modifications, layout preferences, additional features, etc."
										/>
									</div>
									{this.state.customizedPlanError && (
										<p className="text-danger small mb-2">{this.state.customizedPlanError}</p>
									)}
									<button type="submit" className="fp-modal-submit" disabled={this.state.customizedPlanSubmitting}>
										{this.state.customizedPlanSubmitting ? 'Sending…' : 'Submit Request'}
									</button>
								</form>
							</div>
						</div>
					)}
				</div>
				<FooterPremium />
			</Fragment>
		);
	}
}

export default FloorPlans;
